import { COLORS } from "utils/colors";

export const GNSSStatusTable = (props) => {
  const getPerformanceTableRow = (
    data,
    constellation,
    errorType,
    inferiorLimit,
    superiorLimit
  ) => {
    if (!data || !data[constellation] || !data[constellation][errorType]) {
      return <td className="text-center text-nowrap text-truncate" style={{ maxWidth: "50px" }}>N/A</td>;
    }

    const errorValue = data[constellation][errorType];

    if (errorValue === 9999) {
      return <td className="text-center text-nowrap text-truncate" style={{ maxWidth: "50px" }}>Insufficient data</td>;
    }

    let backgroundColor = "";
    if (errorValue < inferiorLimit) {
      backgroundColor = "green";
    } else if (errorValue < superiorLimit) {
      backgroundColor = "yellow";
    } else {
      backgroundColor = "red";
    }

    return (
      <td className="text-center">
        <div
          title={errorValue}
          style={{
            margin: "auto",
            borderRadius: 15,
            width: 40,
            height: 15,
            background: backgroundColor,
          }}
        ></div>
      </td>
    );
  };

  return (
    <>
      <table
        className="table table-sm table-bordered"
        style={{
          borderCollapse: "collapse",
          borderRadius: "10px",
          borderStyle: "hidden",
          boxShadow: `0 0 0 3px ${COLORS.ligthGrey}`,
        }}
      >
        <thead>
          <tr>
            <th className="text-center " colSpan="4">
              {props.title || "GNSS core constellations status"}
            </th>
          </tr>
          <tr>
            <th className="text-center" style={{ width: "15%" }}></th>
            <th className="text-center" style={{ width: "30%" }}>GPS</th>
            <th className="text-center" style={{ width: "30%" }}>GLONASS</th>
            <th className="text-center" style={{ width: "30%" }}>GALILEO</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th className="text-center">HPE</th>
            {getPerformanceTableRow(
              props.performanceTableData,
              "gps",
              "hpe",
              8.1,
              9.9
            )}
            {getPerformanceTableRow(
              props.performanceTableData,
              "glo",
              "hpe",
              4.5,
              5.5
            )}
            {getPerformanceTableRow(
              props.performanceTableData,
              "gal",
              "hpe",
              6.75,
              8.25
            )}
          </tr>
          <tr>
            <th className="text-center">VPE</th>
            {getPerformanceTableRow(
              props.performanceTableData,
              "gps",
              "vpe",
              13.5,
              16.5
            )}
            {getPerformanceTableRow(
              props.performanceTableData,
              "glo",
              "vpe",
              8.1,
              9.9
            )}
            {getPerformanceTableRow(
              props.performanceTableData,
              "gal",
              "vpe",
              13.5,
              16.5
            )}
          </tr>
        </tbody>
      </table>
    </>
  );
};
